import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';
import {User} from "../models/user";
import {UserToken} from "../models/userToken";


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  public activeUser: User;
  public activeToken: UserToken;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public set(key: string, value: any) {
    this._storage?.set(key, value);
  }

  public get(key: string): Promise<any> {
    return this._storage?.get(key);
  }
}
